import { Smartphone, Download, AlertCircle } from 'lucide-react';

export const FallbackScreen = () => {
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <div className="bg-elevated border border-subtle rounded-xl p-8 max-w-md w-full text-center">
        <div className="mb-6">
          <AlertCircle className="w-16 h-16 text-status-warning mx-auto mb-4" />
          <h1 className="text-2xl font-bold text-th-primary mb-2">
            Access Required
          </h1>
          <p className="text-th-secondary">
            This app requires access through the Hyper app with a valid session ID. Please download and activate the correct plan to continue.
          </p>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-center space-x-4 mb-6">
            <Smartphone className="w-6 h-6 text-brand" />
            <span className="text-th-secondary">Available on mobile</span>
          </div>

          <div className="space-y-3">
            <a
              href="https://apps.apple.com/app/hyper"
              target="_blank"
              rel="noopener noreferrer"
              className="button-primary w-full flex items-center justify-center space-x-2"
            >
              <Download className="w-5 h-5" />
              <span>Download on App Store</span>
            </a>

            <a
              href="https://play.google.com/store/apps/details?id=com.hyper"
              target="_blank"
              rel="noopener noreferrer"
              className="button-secondary w-full flex items-center justify-center space-x-2"
            >
              <Download className="w-5 h-5" />
              <span>Get it on Google Play</span>
            </a>
          </div>

          <div className="mt-6 p-4 bg-surface border border-subtle rounded-xl">
            <p className="text-sm text-th-secondary">
              After installing, open the Hyper app and activate a compatible plan to access this app. The session ID parameter is mandatory for data synchronization.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
